import type { FaireProductEntity } from "../../entity_types/product";

export const p_mnxxywbn3z: FaireProductEntity = {
  token: "p_mnxxywbn3z",
  type: "product",
  name: "Ear seeding / Acupressure At Home Kit 12pc",
  brandToken: "b_p9ea6rv64x",
  brandName: "La Lune Healing",
  imageUrl:
    "https://cdn.faire.com/fastly/4cb7fc277fa256511c57e897642b5c5dde5cedd2cac92bce8b43e89bca1c1084.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2d0a77a2e94285cbd2e2ffe428e3cd94f44039076ed9ca2b66c2e9ae39ea74f6.jpeg",
    "https://cdn.faire.com/fastly/96c2cdf6d9f8344c9807ffa8afefe5749921fcd8c90739be25b51629dd79fc2f.jpeg",
    "https://cdn.faire.com/fastly/a44e0e3db29c9ea746bb0d9e07577ecb1a5e78708f16763b59daa3b0f31a3b2e.jpeg",
  ],
  priceDollars: 7,
  description:
    "Ear seed  treatment helps prompt the body to heal. Used to reduce stress, relieve pain, restore hormonal balance and much more. Ear seeds are an amazing way to get the same benefits of acupuncture & acupressure at home.\n\nPlace these tiny adhesive seeds on various acupressure points to stimulate relief and promote overall wellness.\n\nIncludes:\n-12 individual Ear Seeds ( Made from natural, dried Vaccaria seeds)\n-Tweezers for easy application on acu-points\n-100% latex free medical grade adhesive\n-How-To Guide including key acupressure points \n\nApplication and Use:\nWash and dry your ears carefully.\nUse the chart that comes with the seeds\nApply the seeds using tweezers\nGently massage each ear seed throughout the day. Leave seeds on for 3-5 days\n\nSafe Removal:\nTilt your head forward toward the floor so the seeds don’t fall in your ear canal. Use your fingers or tweezers to pick them out.Let the ear area rest for two to three days before you apply more seeds.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:17.824Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
